import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import classes from './DayFilter.module.scss';
import BasicFilterDropdown from '../BasicFilterDropdown/BasicFilterDropdown';
import CustomCalendarPicker from '../../../../CustomWeekPicker/CustomCalendarPicker';
import { calendarTypes, responsiveSizeTimesheet } from '../../../../../../utils/constants';
import { useWindowSize } from '../../../../../../utils/hooks';
import MainButton from '../../../../buttons/MainButton';

export default function DayFilter({ day = '', changeDay }) {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const size = useWindowSize();

  return (
    <BasicFilterDropdown
      type={t('dashboard.timesheets.filters.day')}
      text={t('dashboard.timesheets.filters.day')}
      active={!!day}
      open={open}
      setOpen={setOpen}
    >
      <div className={classes.container}>
        {day && size.width < responsiveSizeTimesheet && (
          <div
            role="presentation"
            className={classes.resetTxtBtn}
            onClick={() => {
              changeDay('');
              setOpen(false);
            }}
          >
            {t('dashboard.timesheets.filters.reset').split(' ')[0]}
          </div>
        )}
        <CustomCalendarPicker
          userDate={!day ? '' : dayjs(day)}
          setUserDate={(pickedDay) => {
            changeDay(dayjs(pickedDay.toString()).format('DD-MMM-YYYY'));
            if (size.width > responsiveSizeTimesheet) setOpen(false);
          }}
          calendarType={calendarTypes.DAY}
        />
        {day && size.width > responsiveSizeTimesheet && (
          <MainButton
            outlined
            rounded
            size={size.width < responsiveSizeTimesheet ? 'small' : 'xsmall'}
            forceWidth={size.width < responsiveSizeTimesheet ? '100%' : '136px'}
            action={() => {
              changeDay('');
              setOpen(false);
            }}
          >
            <p>{t('dashboard.timesheets.filters.reset')}</p>
          </MainButton>
        )}
      </div>
    </BasicFilterDropdown>
  );
}
